import { Banner } from '@sunwebgroup/uds-ui/banner'
import { Skeleton } from '@sunwebgroup/uds-ui/skeleton'
import { useIntl } from 'react-intl'
import { useBookingDetailsStore } from '../../infrastructure/useBookingDetailsStore'
import { getTransferCardsAlignment } from '../selectors/transferSelectors'
import { BookingDetailsSection } from './BookingDetailsSection'
import { TransferCard } from './TransferCard'
import styles from './TransfersSection.module.css'

export function TransfersSection() {
  const { formatMessage } = useIntl()
  const transfers = useBookingDetailsStore(state => state.transfers)
  const { type: transferType, outbound, inbound, loadStatus } = transfers
  const alignRows = useBookingDetailsStore(getTransferCardsAlignment)

  if (transferType === null || loadStatus === 'idle')
    return null

  const isPrivate = transferType === 'Private'

  return (
    <BookingDetailsSection
      iconName={isPrivate ? 'CarRight' : 'BusRight'}
      title={formatMessage({ id: isPrivate ? 'booking_details_private_transfers_title' : 'booking_details_transfers_title' })}
      description={formatMessage({ id: 'booking_details_transfers_description' })}
    >
      {loadStatus === 'loading' && (
        <div className={styles.cards}>
          <Skeleton className={styles.skeletonCard} />
          <Skeleton className={styles.skeletonCard} />
        </div>
      )}

      {loadStatus === 'error' && (
        <Banner color="danger" size="M" hasIcon contentIsCentered>
          <Banner.Text>{formatMessage({ id: 'booking_details_transfers_error_text' })}</Banner.Text>
        </Banner>
      )}

      {loadStatus === 'success' && (
        <div className={styles.cards}>
          <TransferCard
            title={formatMessage({ id: 'booking_details_transfers_outbound_title' })}
            noTransferTitle={formatMessage({ id: 'booking_details_transfers_outbound_no_transfer_title' })}
            noTransferDescription={formatMessage({ id: 'booking_details_transfers_outbound_no_transfer_description' })}
            transferType={transferType}
            transfer={outbound}
            transferDirection="outbound"
            alignRows={alignRows}
          />
          <TransferCard
            title={formatMessage({ id: 'booking_details_transfers_inbound_title' })}
            noTransferTitle={formatMessage({ id: 'booking_details_transfers_inbound_no_transfer_title' })}
            noTransferDescription={formatMessage({ id: 'booking_details_transfers_inbound_no_transfer_description' })}
            transferType={transferType}
            transfer={inbound}
            transferDirection="inbound"
            alignRows={alignRows}
          />
        </div>
      )}
    </BookingDetailsSection>
  )
}
